/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Md Moniruzzaman Sojol",
  title: "I'm Sojol",
  subTitle: emoji(
    "A passionate Front End Developer 🚀 having an experience of designing and building Web  applications with JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/uc?export=download&id=1u_BAXVt115CIqpgjhLBz-BXd4ndb8eDS",
  displayGreeting: true // Set false to hide this section, defaults to true
};
// https://drive.google.com/file/d/1u_BAXVt115CIqpgjhLBz-BXd4ndb8eDS/view?usp=sharing
// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/sojol4242",
  linkedin: "https://www.linkedin.com/in/moniruzzaman-eee/",
  gmail: "bsmrstueee90gmail.com",
  // gitlab: "https://gitlab.com/",
  // facebook: "https://www.facebook.com/",
  medium: "https://bsmrstueee90.medium.com/",
  // stackoverflow: "https://stackoverflow.com/users/13263979/drakosi",
  // instagram: 'https://www.instagram.com/davidrakosi/',
  // twitter: 'https://twitter.com/davidrakosi_',
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I can",
  subTitle: "CRAZY Front End Developer WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web applications"
    ),
    
    emoji(
      "⚡ Integration of third party services such as Firebase"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "mongodb",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    } 
  ],
  display: true // Set false to hide this section, defaults to true
};
const aboutSection = {
  title: "About ME",
  subTitle:"A self-motivated and passionate front end developer with a deep interest in software development world.Work with modern technologies of different local & multinational Software/ IT firm and grow rapidly with increasing responsibilities. I am easy to communicate with and good with teamwork. Looking forward to build career in software industry. Also I love to teach and share knowledge to everyone",
  display:false,
 
}
// Education Section
const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Bangabandhu sheikh Mujibur Rahman Science And Technology University",
      logo: require("./assets/images/bsmrstulogo.jpg"),
      subHeader: "Bachelor of Science in Electrical And Electronic Engineering",
      duration: "January 2020 - present",
      desc: "First year second semester's student",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    } 
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend / Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "40%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display:true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Web Developer Intern",
      company: "Cyber Chasse Inc.",
      companylogo: "https://media-exp1.licdn.com/dms/image/C560BAQGadRKDCo60bA/company-logo_200_200/0/1548790900314?e=2159024400&v=beta&t=4v2llZDnokxn6g_Nxz3COTcWuga2jjozPF8TGAcpuBo",
      date: "May 2021 – July 2021",
      desc:
        "Now I am working here as a intern. It is a nice place to work with this company.",
      descBullets: [
        "Custom building applications",
        "Coaching",
        
      ]
    } 
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "drakosi99", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false// Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Recent Projects",
  subtitle: "Here is my latest works on development.",
  projects: [
    {
      image: require("./assets/images/covid.png"),
      projectName: "Covid-19 tracker",
      projectDesc: "It is a covid-19 tracker app. Where user can see the latest data of covid-19.In this project I was working with react's basic concepts. After one day data will be changed through the API",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://covid-tracker-2021.netlify.app/"
        },
        {
          name: "Github",
          url: "https://github.com/sojol4242/covid-19-tracker"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/photo.png"),
      projectName: "Picturesque",
      projectDesc: "User can use this app through google authentication. Also user can add service by choosing himself/herself and order it by through stripe payment gateway(test card ). This app also has a admin panel who control the services and also order",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://picturesque-100db.web.app/"
        },
        {
          name: "github",
          url: "https://github.com/sojol4242/photography"
        }
      ]
    },
    {
      image: require("./assets/images/netflix (1).png"),
      projectName: "Netflix-Clone(Front-End)",
      projectDesc: "User can use this app through firebase email password authentication. And also see the latest movie and series but it is like a landing page. Many much core Netflix functionality I can't implement.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://netflix-clone-bf4fd.web.app/"
        },
        {
          name: "github",
          url: "https://github.com/sojol4242/Netflix-clone"
        }
      ]
    },
    {
      image:"https://i.ibb.co/7R2rDBk/Screenshot-13-1.png",
      projectName: "Laptop-Bazar",
      projectDesc: "User can use this app through firebase email password authentication. And also Order a laptop.User also able to see his/her order lists.Admin can control The admin dashboard",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://laptop-bazar-2e5ba.web.app/"
        },
        {
          name: "github",
          url: "https://github.com/Porgramming-Hero-web-course/full-stact-explore"
        }
      ]
    },
    {
      image:"https://i.ibb.co/GWCnCbX/amazon.png",
      projectName: "Amazon-Clone(Front-End)",
      projectDesc: "User can use this app through firebase email password authentication. And also place order like AMAZON .User also able to see his/her order lists and also see the cart.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://clone-react-firebase-ac52c.web.app/"
        },
        {
          name: "github",
          url: "https://github.com/sojol4242/amazon-clone"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      // image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url:
            ""
        },
        {
          name: "Award Letter",
          url:
            ""
        },
        {
          name: "Google Code-in Blog",
          url:
            ""
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      // image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url:
            ""
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      // image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: ""
        }
      ]
    }
  ],
  display: false// Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://bsmrstueee90.medium.com/introduction-to-react-js-18d118fe9ac8",
      title: "Explore what is REACT?",
      description:
        "On this blog i talked about what is react? why react? and some of the base concept to start with react"
    },
    {
      url: "https://bsmrstueee90.medium.com/javascripts-fundamental-2d39d7695f7e",
      title: "Talk with Javascript",

      description:
        "On this blog i talked about some Javascripts topics like string,number,math and so on."
    },
    {
      url: "https://bsmrstueee90.medium.com/how-to-write-a-research-paper-752ae2000de6",
      title: "How to write a Research Paper",

      description:
        "On this blog i talked about some basic idea those help you to write a a research paper"
    }
     
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "Let's talk",
  subtitle: emoji(
    "📩"
  ),

  
  display: false// Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+8801790678711",
  email_address: "bsmrstueee90@gmail.com"
};

// facebook Section

const twitterDetails = {
  userName: "davidrakosi_", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  aboutSection
};

// Sad Pasta